import React, { useEffect } from "react";
import CashPosition from "../Body/CashPosition/CashPosition";
import ChartContainer from "../Body/ChartContainer";
import KeyStatistics from "../Body/KeyStatistics/KeyStatistics";
import useQueryParams from "../../hooks/useQueryParams";
import useStockInfo from "../../hooks/useStockInfo";
import { AddHistory } from "../../exports/HistoryStorage";
import useAccount from "../../hooks/useAccount";
import { ArrowLeft } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";

function StrategyDashboard({ setSymbol, OpenOrderPopup }) {
  return (
    <div className="app__body">
      <div className="app__body__bottom">
        <StrategyDashboardLeft setSymbol={setSymbol} OpenOrderPopup={OpenOrderPopup} />
        <div className="app__body__right">
          <CashPosition />
        </div>
      </div>
    </div>
  );
}

function StrategyDashboardLeft({ setSymbol, OpenOrderPopup }) {
  const query = useQueryParams();
  const { symbol: query_symbol = "HDFCBANK" } = query;

  const { account } = useAccount();

  const { stock_info } = useStockInfo(query_symbol);

  useEffect(() => {
    if (!stock_info) return;
    const { account_code } = account;
    const { symbol, company, exchange } = stock_info;
    AddHistory(account_code, { symbol, company, exchange, type: "STOCKS" });
  }, [stock_info]);

  useEffect(() => {
    if (setSymbol) {
      setSymbol(query_symbol);
    }
  }, [query_symbol]);

  return (
    <div className="app__body__left" id="chart-modal">
      <ChartContainer key={`chart-${query_symbol}`} symbol={query_symbol} OpenOrderPopup={OpenOrderPopup}/>
      <KeyStatistics key={`stats-${query_symbol}`} symbol={query_symbol} />
    </div>
  );
}

export default StrategyDashboard;
